<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="authAcceptorSubmit_tooltip_NAME"  :name="authAcceptorSubmit_tooltip_NAME" :description="authAcceptorSubmit_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row justify-content-center">
      <div class="col-sm-6 content_padding_top">
        <base-input label=" Name (Last, First, MI, Rank / Title)">
          <base-input
            :disabled="isReadOnly || isPartnerAccount"
             data-vv-as="Name"
            v-model="authorizedAcceptor.acceptorName"
            name="authorizedAcceptorName"
            v-validate="'required|max:300'"
            :error="getError('authorizedAcceptorName')"
          >
          </base-input>
        </base-input>
      </div>
      <div class="col-sm-6 content_padding_top">
        <base-input label="Accepting Unit / Office">
          <base-input
            :disabled="isReadOnly || isPartnerAccount"
            data-vv-as="Accepting Unit / Office"
            v-model="authorizedAcceptor.acceptorUnitOffice"
            name="acceptingUnitOffice"
            v-validate="'required|max:300'"
            :error="getError('acceptingUnitOffice')"
          >
          </base-input>
        </base-input>
      </div>
      <div class="col-sm-12 content_padding_top">
        <label>Accepting Nation / Organization</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="authorizedAcceptor.acceptorOrganizationId"
          :reduce="(organizationOption) => organizationOption.id"
          label="name"
          name="acceptingNation"
          data-vv-as="Accepting Nation / Organization"
          :options="authorizedAcceptor.organizations"
          placeholder="Select one"
          :class="errors.has('acceptingNation') ? 'has-danger' : ''"
          v-validate="'required'"
          :error="getError('acceptingNation')"
        ></v-select>
         <span v-show="errors.has('acceptingNation')" class="error"
          >Accepting Nation / Organization is required
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 content_padding_top">
        <div class="pull-right">
          <base-button
            type="primary"
            wide
            :disabled="isReadOnly || isPartnerAccount"
            @click.native="submit"
            class="btn-next"
            >Save</base-button
          >
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
import toolTip  from "../../../Tooltip";

export default {
  props: ["isReadOnly"],
  name: "AuthorizedAcceptorSubmit",
  components: {
    toolTip
  },
  data() {
    return {
      authAcceptorSubmit_tooltip_NAME : '',
      authAcceptorSubmit_tooltip_DESCRIPTION : ''
    };
  },
  async mounted(){
    await this.getAllTooltips()
    this.loadToolTips()
  },
  computed: {
    ...mapGetters({
      authorizedAcceptor: "authorizedAcceptor/authorizedAcceptor",
      authorizedAcceptorErrors: "authorizedAcceptor/authorizedAcceptorErrors",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus: "agreementInformation/agreementInformationStatus",
      authorizedAcceptorHelper: "authorizedAcceptor/authorizedAcceptorHelper",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions({
      loadAuthorizedAcceptor: "authorizedAcceptor/getAuthorizedAcceptor",
      getAuthorizedAcceptorSubmitStatus: "authorizedAcceptor/getAuthorizedAcceptorSubmitStatus",
      getAuthorizedAcceptorHelper: "authorizedAcceptor/getAuthorizedAcceptorHelper",
      getAllTooltips: "tooltip/getToolTips", 
    }),
    loadToolTips(){
    const authAcceptorSubmitVal = this.toolTips.find(e => e.name === "AuthAcceptorModule")
  if(authAcceptorSubmitVal && authAcceptorSubmitVal.status){
    this.authAcceptorSubmit_tooltip_DESCRIPTION = authAcceptorSubmitVal.description ? authAcceptorSubmitVal.description: null
      this.authAcceptorSubmit_tooltip_NAME = authAcceptorSubmitVal.name ? authAcceptorSubmitVal.name: null
  }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    async loaded() {
      let ctx = this;

      await ctx.getAuthorizedAcceptorHelper(ctx.getOrderIdFromRoute);

      const params = {
        buySell: ctx.authorizedAcceptorHelper.buySell,
        countryId: ctx.authorizedAcceptorHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      await ctx.$store.dispatch("authorizedAcceptor/getOrganizations", params);
      await ctx.loadAuthorizedAcceptor(ctx.getOrderIdFromRoute);
    },
    showAuthorizedAcceptorSubmitErrors () {
        if(this.authorizedAcceptorErrors.length > 0 ) {
            this.authorizedAcceptorErrors.forEach(error => this.$toast.error(error))
        } else {
          this.$toast.success("Authorized Acceptor Module saved successfully");
        }
        },
    async submit(e) {
      var result = await this.$validator.validateAll(); 
      if (result) {
        this.$loaderApp.addRequest();
        let ctx = this;
        let data = {
            orderId: this.getOrderIdFromRoute,
            pin: null
        };
        await this.$store
          .dispatch(
            "authorizedAcceptor/saveAuthorizedAcceptor",
            data
          );
        await this.getAuthorizedAcceptorSubmitStatus(this.$route.params.id); 
        await this.showAuthorizedAcceptorSubmitErrors();
        await this.loadAuthorizedAcceptor(ctx.getOrderIdFromRoute);
        this.$loaderApp.completeRequest();

      } else {
        this.$toast.error("Please fill the required fields.");
        this.$loaderApp.completeRequest();
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
};
</script>

<style>
.content_padding_top {
  padding-top: 20px;
}

.content_padding_top_small {
  padding-top: 5px;
}
</style>
